// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__25vB1","title":"AfterBackImages_title__1QHwk","images":"AfterBackImages_images__3ZRpK"};